import React from 'react';
import { motion } from 'framer-motion';
import { LightbulbIcon, TargetIcon, UsersIcon, MessageSquareIcon, TrendingUpIcon, CalendarIcon } from 'lucide-react';
export function IncludesSection() {
  const modules = [{
    title: '1) Claridad',
    icon: LightbulbIcon,
    items: ['Checklist de habilidades monetizables', 'Ejercicio de propósito práctico']
  }, {
    title: '2) Idea ganadora',
    icon: TargetIcon,
    items: ['Tabla de puntuación para elegir una idea', 'Ejemplos de productos low ticket (solo referencia)']
  }, {
    title: '3) Audiencia ideal',
    icon: UsersIcon,
    items: ['Plantillas para definir a quién ayudas y qué le duele', 'Prompts para escribir como tu audiencia habla']
  }, {
    title: '4) Oferta',
    icon: MessageSquareIcon,
    items: ['Fórmula "oferta en 1 frase"', 'Cómo sostener tu precio con calma y seguridad']
  }, {
    title: '5) Contenido + ventas',
    icon: TrendingUpIcon,
    items: ['15 ideas de contenido', 'Hooks para Reels', 'Guiones de Stories', 'Script de DM para vender sin sentirte invasiva']
  }, {
    title: '6) Implementación',
    icon: CalendarIcon,
    items: ['Plan completo día por día (14 días)']
  }];
  return <section className="py-20 px-4 bg-cream-50" data-id="element-139">
      <div className="max-w-6xl mx-auto" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-141">
          <h2 className="text-3xl md:text-5xl font-serif text-brown-800 mb-4" data-id="element-142">
            Dentro del Plan 14 Días encuentras:
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-143">
          {modules.map((module, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-cream-200 hover:shadow-md transition-shadow" data-id="element-144">
              <div className="flex items-center gap-4 mb-6" data-id="element-145">
                <div className="bg-cream-100 p-3 rounded-xl" data-id="element-146">
                  <module.icon className="w-6 h-6 text-terracotta-500" data-id="element-147" />
                </div>
                <h3 className="text-xl font-bold text-brown-800" data-id="element-148">
                  {module.title}
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-149">
                {module.items.map((item, i) => <li key={i} className="text-stone-600 text-sm md:text-base leading-relaxed pl-4 border-l-2 border-cream-200" data-id="element-150">
                    {item}
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-12 text-center" data-id="element-151">
          <div className="inline-block bg-sage-500/10 text-sage-800 px-6 py-3 rounded-lg border border-sage-500/20" data-id="element-152">
            <span className="font-bold" data-id="element-153">Nota:</span> Incluye un ejemplo completo
            llamado <span className="italic" data-id="element-154">"Mañanas sin Caos"</span> para ver
            cómo se estructura un producto vendible por dentro.
          </div>
        </motion.div>
      </div>
    </section>;
}